// extracted by mini-css-extract-plugin
module.exports = {"MovieDetailsContent":"MovieDetails_MovieDetailsContent__1KAUG"};